module.exports = __webpack_public_path__ + "img/telegram-color.45d9f2c6.svg";